<template>
  <div :id="profId">
    <base-card class="mb-4">
      <div class="main-block">
        <div class="media-block">
          <img class="search-photo mb-3" :src="photo">
          <div v-if="rating.total > 0">
            <div class="rating">
              <span v-for="n in 5" :key="`rating-${n}`">
                <component :is="ratingComponent(n)" font-scale="1.3"></component>&nbsp;
              </span>
              <span class="rating-mobile" v-if="!xlScreen" v-html="`(${rating.total})`"></span>
            </div>
            <label v-if="xlScreen" class="califications" v-html="`${rating.total} ${$t('ratings')}`"></label>
          </div>
          <div v-if="xlScreen" class="mt-3">
            <base-button class="request-companies-appointment" @click="defaultServiceAction">{{defaultServiceTitle}}</base-button>
          </div>
        </div>
        <div class="info-block">
          <div>
            <a class="search-name" :href="$helpers.getCustomPageUrl(customPageUrl)" target="_blank">{{`${name} ${surnames}`}}</a>
          </div>
          <ul class="specialties-list mt-2">
            <li v-for="item in specialties" class="mr-3 mb-3" :key="item.id" v-html="$i18nHelpers.normalize(item.name)"></li>
          </ul>
          <div v-if="subspecialtiesToShow.length > 0">
            <ul class="subspecialties-list">
              <b class="inline-block mr-3 mb-3">{{$t('specialistIn')}}:</b> <li v-for="item in subspecialtiesToShow" class="mr-3 mb-3" :key="item.id" :class="item.id === -1 ? 'clickable' : null" v-on="item.id === -1 ? {click: showMoreSubspecialties} : {}" v-html="`${item.id === -1 ? item.name : $i18nHelpers.normalize(item.name)}`"></li>
            </ul>
          </div>
          <p class="introductory-text" v-if="introductoryText" v-html="introductoryText"></p>
          <ul class="languages-list">
            <li v-for="item in languagesToShow" class="mr-3 mb-3" :key="item.code">
              <span v-html="item.language" :class="item.code === -1 ? 'clickable' : null" v-on="item.code === -1 ? {click: showMoreLanguages} : {}"></span>
            </li>
          </ul>
          <div v-if="!xlScreen" class="mt-3">
            <base-button class="request-companies-appointment" @click="defaultServiceAction">{{defaultServiceTitle}}</base-button>
          </div>
        </div>
      </div>
    </base-card>
  </div>
</template>

<script>
import SearchServiceTypeBlock from '../SearchServiceTypeBlock.vue'
import BaseCard from '@/components/base/ui/BaseCard'
import { PROFESSIONAL_MALE_DEFAULT_IMAGE, PROFESSIONAL_FEMALE_DEFAULT_IMAGE } from '@/constants/images'
import { MALE } from '@/constants/genders'
import { CALL, CHAT, IMMEDIATE_VIDEO, WRITTEN } from '@/constants/consultationTypes'
import { SCREEN_XL_GRID_MAX } from '@/constants/mediaQueries'

export default {
    props: {
      profId: String,
      rating: Object,
      customPageUrl: String,
      name: String,
      surnames: String,
      specialties: Array,
      subspecialties: Array,
      introductoryText: String,
      languages: Array,
      photoUri: String,
      gender: String,
      patientInfo: Object
    },
    components: {
      BaseCard,
      SearchServiceTypeBlock
    },
    data () {
      return {
        languagesReduced: [],
        showAllLanguages: false,
        subspecialtiesReduced: [],
        showAllSubspecialties: false
      }
    },
    mounted () {
      this.mapLanguagesList()
      if (this.subspecialtiesToShow.length > 0) this.mapSubspecialtiesList()
    },
    computed: {
      photo () {
        return this.photoUri || (this.gender === MALE || !this.gender ? PROFESSIONAL_MALE_DEFAULT_IMAGE : PROFESSIONAL_FEMALE_DEFAULT_IMAGE)
      },
      defaultServiceTitle () {
        return this.$t('requestConsultation')
      },
      requestAppointmentTitle () {
        return this.currentSelectedServiceId && (this.currentSelectedServiceId === WRITTEN ? this.$t('sendConsultation') : this.currentSelectedServiceId === IMMEDIATE_VIDEO || this.currentSelectedServiceId === CHAT ? this.$t('makeConsultation') : this.currentSelectedServiceId === CALL ? this.$t('requestCall') : this.$t('requestAppointment'))
      },
      xlScreen () {
        return window.innerWidth > SCREEN_XL_GRID_MAX
      },
      languagesToShow () {
        return !this.languagesReduced.length || this.showAllLanguages ? this.languages : this.languagesReduced
      },
      subspecialtiesToShow () {
        return !this.subspecialtiesReduced.length || this.showAllSubspecialties ? this.subspecialties : this.subspecialtiesReduced
      }
    },
    created () {
    },
    methods: {
      showMoreLanguages () {
        this.showAllLanguages = true
      },
      showMoreSubspecialties () {
        this.showAllSubspecialties = true
      },
      showMoreCenters () {
        this.showAllCenters = true
      },
      mapLanguagesList () {
        this.$nextTick(() => {
          let languagesListOffset = document.querySelector(`[id='${this.profId}'] ul.languages-list`).offsetWidth
          let languageItems = document.querySelectorAll(`[id='${this.profId}'] ul.languages-list > li`)
          let totalWidth = 0
          let languages = []
          for (let i = 0; i < languageItems.length; i++) {
            let item = languageItems[i]
            let width = item.offsetWidth
            let marginRight = parseInt(getComputedStyle(item).marginRight)
            totalWidth += width + marginRight
            if (totalWidth > languagesListOffset && i >= 1) {
              let languagesInputLength = this.languages.length
              languages[i - 1] = {code: -1, language: `+${languagesInputLength - (languages.length - 1)}`}
              this.languagesReduced = languages
              break
            }
            languages.push(this.languages[i])
          }
        })
      },
      mapSubspecialtiesList () {
        this.$nextTick(() => {
          let listOffset = document.querySelector(`[id='${this.profId}'] ul.subspecialties-list`).offsetWidth
          let items = document.querySelectorAll(`[id='${this.profId}'] ul.subspecialties-list > li`)
          let totalWidth = 0
          let result = []
          let maxRows = 2
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            let width = item.offsetWidth
            let marginRight = parseInt(getComputedStyle(item).marginRight)
            totalWidth += width + marginRight
            if (totalWidth > listOffset * maxRows && i >= 1) {
              let inputLength = this.subspecialties.length
              result[i - 1] = {id: -1, name: `+${inputLength - (result.length - 1)}`}
              this.subspecialtiesReduced = result
              break
            }
            result.push(this.subspecialties[i])
          }
        })
      },
      ratingComponent (iteration) {
        return iteration <= this.rating.value ? 'b-icon-star-fill' : 'b-icon-star'
      },
      defaultServiceAction () {
        window.open(this.$helpers.getCustomPageUrl(this.customPageUrl))
      }
    }
}
</script>

<style lang="scss" scoped>
.main-block{
  display: flex;
  flex-direction: row;
  @include screen-xl-grid-max {
    flex-direction: column;
  }
}
.media-block{
  text-align: center;
  flex: 0 0 150px;
}
.info-block{
  flex: fit-content;
  // remove padding when mobile view
  padding-left: 4rem;
  @include screen-xl-grid-max  {
    text-align: center;
    padding-left: 0;
  }
}
.search-photo{
  border-radius: 100%;
  padding: 0;
  box-shadow: 14px 14px 25px #0d275029;
  margin: auto;
  margin-bottom: auto;
  max-width: 100%;
  width: 150px;
  height: 150px;
  @include screen-xl-grid-max{
    width: 120px;
    height: 120px;
  }
}
.search-name{
  display: inline-block;
  font-size: 1.5em;
  text-decoration: underline;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  @include screen-xl-grid-max  {
    font-size: 1.2rem;
  }
}
.block{
  display: block;
}
.info-block ul{
  padding-left: initial;
  li{
    display: inline-block;
    text-align: center;
    border: 1px solid #8a8a8a;
    background-color: transparent;
    border-radius: 23px;
  }
}
.specialties-list{
  margin-bottom: 0;
  li{
    padding: 3px 10px;
    font-size: 14px;
    line-height: 26px;
  }
}
.subspecialties-list{
  margin-bottom: 0;
  li{
    padding: 3px 10px;
    font-size: 14px;
    line-height: 26px;
  }
}
.languages-list{
  margin-bottom: 0;
  li{
    padding: 1px 10px;
    font-size: 13px;
  }
}
.rating{
  text-align: center;
  .b-icon{
    color: $blue;
  }
}
.califications{
  font-size: smaller;
  color: $gray;
}
.blue{
  color: $blue;
}
.favourite{
  font-size: small;
  color: $blue;
  cursor: pointer;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  @include screen-xl-grid-max  {
    margin-top: 0.5rem;
  }
}
.bold{
  font-weight: bold;
}
.prof-logo{
  width: 45px;
  height: 30px;
  cursor: pointer;
}
.service-type{
    display: flex;
    gap: 2rem;
}
.introductory-text{
  margin-top: 0;
  margin-bottom: 1rem;
}
.rating-mobile{
  position: absolute;
}
.show-more-centers{
  cursor: pointer;
  text-decoration: underline;
  color: $blue;
}
.inline-block{
  display: inline-block;
}
.request-companies-appointment{
  font-size: 0.85rem;
  padding: .5rem 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/search/companies/SearchCompaniesBlock.vue